// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__j45-g"};